import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginPageImg from "../assets/Group-140.png";
import LogoKT from "../assets/Logo - Admin.png";
import LoadingOverlay from "../components/general/LoadingOverlay";
import { jwtDecode } from "jwt-decode";
import {
  Box,
  Flex,
  Card,
  Image,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Button,
  Spinner,
  Stack,
  useToast,
  Divider
} from "@chakra-ui/react";


const Login = () => {
  const navigate = useNavigate();
  const toast = useToast();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const loginAPI = process.env.REACT_APP_API_URL + "/api/admin/login/";

  const fetchKeycloakTokens = async (u, p) => {
    const realmBase = process.env.REACT_APP_KC_REALM_BASE || "https://meotrikapm.com/sso/realms/DEV-REALM";
    const params = new URLSearchParams({
      grant_type: "password",
      client_id: process.env.REACT_APP_KC_CLIENT_ID || "kt-admin-app",
      username: u,
      password: p,
      scope: "openid profile email",
    });
    const clientSecret = process.env.REACT_APP_KC_CLIENT_SECRET;
    if (clientSecret) params.append("client_secret", clientSecret);

    const tokenEndpoint = `${realmBase}/protocol/openid-connect/token`;
    const resp = await fetch(tokenEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: params,
    });
    if (!resp.ok) throw new Error(`Keycloak token error ${resp.status}`);
    const t = await resp.json();
    if (t.id_token) sessionStorage.setItem("id_token", t.id_token);
    if (t.access_token) sessionStorage.setItem("access_token", t.access_token);
    if (t.refresh_token) sessionStorage.setItem("refresh_token", t.refresh_token);
    if (t.expires_in) sessionStorage.setItem("token_expires_at", (Date.now() + t.expires_in * 1000).toString());
    if (t.session_state) sessionStorage.setItem("kc_session_state", t.session_state);
    try {
      if (t.id_token) {
        const kcDecoded = jwtDecode(t.id_token);
        if (kcDecoded?.sid) sessionStorage.setItem("kc_sid", kcDecoded.sid);
      }
    } catch {}
  };

  useEffect(() => {
    const login = localStorage.getItem("login");
    if (login === "true") navigate("/dashboard");

    const loginStatus = localStorage.getItem("loginStatus");
    if (loginStatus) {
      setError(loginStatus);
      setTimeout(() => {
        localStorage.clear();
      }, 3000);
    }

    setTimeout(() => setMsg(""), 3000);
  }, [navigate]);

  const handleInputChange = (e, type) => {
    setError("");
    if (type === "username") {
      setUsername(e.target.value);
      if (e.target.value === "") setError("Kolom Username tidak boleh kosong");
    } else if (type === "password") {
      setPassword(e.target.value);
      if (e.target.value === "") setError("Password tidak boleh kosong");
    }
  };

  const loginSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(loginAPI, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        const messages = {
          400: "The server could not understand the request.",
          401: "Username or Password is incorrect.",
          429: "Too many requests. Please wait.",
          500: "Server error. Try again later.",
        };
        throw new Error(messages[response.status] || `Error ${response.status}`);
      }

      const data = await response.json();
      if (data.status === "error") {
        toast({ status: "error", description: data.message, duration: 5000, isClosable: true });
      } else {
        const decoded = jwtDecode(data.token);
        const d = decoded.data;
        localStorage.setItem("login", true);
        localStorage.setItem("username", username);
        localStorage.setItem("token", data.token);
        localStorage.setItem("id", d.id);
        localStorage.setItem("role_id", d.role_id);
        localStorage.setItem("jobs_id", d.jobs_id);
        localStorage.setItem("team_id", d.team_id);
        localStorage.setItem("company_id", d.company_id);
        localStorage.setItem("jobs", data.jobs);
        localStorage.setItem("teams", data.teams);
        localStorage.setItem("additional_message", data.additional_message);
        localStorage.setItem("access_permissions", JSON.stringify(data.access_permissions));
        localStorage.setItem("profile_picture", data.profile_picture);

        try {
          await fetchKeycloakTokens(username, password);
        } catch (e) {
          console.warn("Keycloak direct-grant failed:", e);
        }
        navigate("/dashboard");
      }
    } catch (error) {
      toast({ status: "error", description: error.message, duration: 5000, isClosable: true });
      console.error("Login error:", error);
    } finally {
      await new Promise((r) => setTimeout(r, 2000));
      setIsLoading(false);
    }
  };

  const loginWithKeycloak = async () => {
    try {
      const { UserManager } = await import("oidc-client-ts");
      const { oidcConfig } = await import("../config/oidcConfig");
      // Temporarily store creds (if provided) to reuse after SSO callback
      try {
        if (username) sessionStorage.setItem("pending_login_username", username);
        if (password) sessionStorage.setItem("pending_login_password", password);
      } catch {}
      const userManager = new UserManager(oidcConfig);
      await userManager.signinRedirect();
    } catch (e) {
      console.error("Keycloak redirect failed:", e);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      loginSubmit();
    }
  };

  const handleClick = () => setShow(!show);

  if (isLoading) return <LoadingOverlay />;

  return (
    <Box h="100vh" bg="white">
      <Flex
        h="100vh"
        p={0}
        m={0}
        direction="column"
        bgImage={`url(${LoginPageImg})`}
        bgPos="bottom"
        bgSize="cover"
        justifyContent="center"
        alignItems="center"
      >
        <Card
          w={{ base: "20em", sm: "25em" }}
          bg="white"
          borderRadius="lg"
          p="20px"
          alignItems="center"
          justifyContent="center"
        >
          <Flex direction="column" gap={4} w="full" alignItems="center">
            <Image src={LogoKT} w="15em" />
            <FormControl>
              <FormLabel>Username</FormLabel>
              <Input
                type="text"
                placeholder="Masukkan Username"
                value={username}
                onChange={(e) => handleInputChange(e, "username")}
                onKeyDown={handleKeyDown}
                isRequired
              />
            </FormControl>

            <FormControl>
              <FormLabel>Password</FormLabel>
              <InputGroup size="md">
                <Input
                  type={show ? "text" : "password"}
                  placeholder="Masukkan Kata Sandi"
                  value={password}
                  onChange={(e) => handleInputChange(e, "password")}
                  onKeyDown={handleKeyDown}
                  isRequired
                />
                <InputRightElement width="4.5rem">
                  <Button h="2rem" size="sm" onClick={handleClick}>
                    {show ? "Hide" : "Show"}
                  </Button>
                </InputRightElement>
              </InputGroup>
            </FormControl>

            <Stack w="full" spacing={4}>
              <Button
                onClick={loginSubmit}
                isDisabled={!username || !password || isLoading}
                bg="#1679AB"
                color="white"
                _hover={{ bg: "#284b69" }}
                borderRadius="md"
              >
                {isLoading ? (
                  <Flex align="center" justify="center" gap={2}>
                    <Box as="span">Redirecting</Box>
                    <Spinner color="white" size="sm" />
                  </Flex>
                ) : (
                  "Login"
                )}
              </Button>

              {/* <Divider />

              <Button
                onClick={loginWithKeycloak}
                bgGradient="linear(to-r, #0099FF, #A2D9FF)"
                color="white"
                borderRadius="md"
                boxShadow="md"
                fontWeight="semibold"
                _hover={{ opacity: 0.9 }}
              >
                Login via Keycloak
              </Button> */}
            </Stack>
          </Flex>
        </Card>
      </Flex>
    </Box>
  );
};

export default Login;
